<div class="header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
    <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
  </button>
</div>
<div class="header d-flex d-md-none align-items-center">
  <h1 class="w-100">{{ title | translate }}</h1>
  <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
    <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
  </button>
</div>
<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
@if (itemsSource) {
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [itemsSource]="itemsSource"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [externalMenuCommandIds]="sidebarMenuActionCommandIds"
    [preferencesKey]="preferencesKey"
    (menuCommand)="onMenuCommand($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    >
  </app-multiselect-list-view>
}

<ng-template #bulkSystemSettingsSidebar>
  <app-company-system-settings-bulk
    [dataContext]="sidebarMenuDataContext"
    [useActionWindow]="false"
    (completed)="onBulkSystemSettingsCompleted()"
    (canceled)="closeSidebarMenuAction()"
  ></app-company-system-settings-bulk>
</ng-template>
